// extracted by mini-css-extract-plugin
module.exports = {"purchaseSuccessfulNotification":"index__purchaseSuccessfulNotification__2-DYr","fadeOut":"index__fadeOut__35edz"};